export type ToolIconKey = string;

export const DEFAULT_TOOL_ICON_KEY = "FileImage";
